import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Customer } from "../model/customer";
import { BreadcrumbItemInterface } from './breadcrumb.service';

@Injectable({
  providedIn: 'root'
})

export class SessionStorageService {
  // Dados de produto/categoria
  private classificationIdentifier: string;
  private classificationName: string;
  private product: string;

  // Dados de pagamento
  private paymentMethodIdentifier: string;
  private paymentMethodIndex: number;
  private coupon: string;

  // Dados de provisionamento
  private userId: string;
  private businessId: string;
  private logon: string;
  private customer: any;
  private validationData: any = {};
  // Variável para controlar se o usuário está recarregando a página
  private is_reloading = false;
  private isPixPaid:boolean;

  private isLogged = false;

  private validatedMitigation = false;

  constructor() {
  }

  /** Obtem a categoria pelo snapshot, atualiza-a no sessionStorage e retorna a string.
   * @input route - ActivatedRoute atual do componente que está chamando o service
   * @returns classification - string com o identificador da categoria
   */

  setValidationToken(route: ActivatedRoute) {
    route.queryParams.subscribe(params => {
      if (params.validationToken) {
        sessionStorage.setItem('validationToken', params.validationToken);
      }
    });
  }

  checkAndSetClassification(route: ActivatedRoute) {
    this.classificationIdentifier = route.snapshot.paramMap.get('classificationIdentifier') ||
      route.parent.snapshot.paramMap.get('classificationIdentifier')

    sessionStorage.setItem('classificationIdentifier', this.classificationIdentifier);

    return this.classificationIdentifier;
  }

  clearSessionStorage(fields?: Array<string>) {
    if (!fields || fields.length === 0) {
      this.resetSessionStorage();
    } else {
      fields.every(field => sessionStorage.removeItem(field));
    }
  }

  /** Verifica se o usuário está recarregando a página */
  isReloading() {
    this.is_reloading = Boolean(sessionStorage.getItem('is_reloading'));
    if (this.is_reloading) {
      return true;
    }

    sessionStorage.setItem('is_reloading', 'true');
    return false;
  }

  setIsLogged(logged: boolean) {
    this.isLogged = logged;
    sessionStorage.setItem('isLogged', logged.toString());
  }

  getIsLogged() {
    return sessionStorage.getItem('isLogged') === 'true';
  }

  setValidatedMitigation(validatedMitigation: boolean) {
    this.validatedMitigation = validatedMitigation;
    sessionStorage.setItem('validatedMitigation', validatedMitigation.toString());
  }

  getValidatedMitigation() {
    return sessionStorage.getItem('validatedMitigation') === 'true';
  }

  resetSessionStorage(force?: boolean) {
    const fields = ['name', 'email', 'userId', 'businessId', 'coupon', 'plan',
      'classificationIdentifier', 'product', 'classificationName', 'customer', 'paymentMethodIndex', 'paymentMethodIdentifier', 'distributor'];
    if (force) {
      fields.forEach(field => {
        sessionStorage.removeItem(field);
      });
    } else {
      fields.every(field => sessionStorage.removeItem(field));
    }

  }


  getClassification(currentRoute?: ActivatedRoute) {
    if (currentRoute) {
      return this.checkAndSetClassification(currentRoute);
    } else {
      return this.classificationIdentifier || sessionStorage.getItem('classificationIdentifier');
    }
  }

  getProduct(): string {
    return this.product || sessionStorage.getItem('product');
  }

  getValidationData(): any {
    return this.validationData || JSON.parse(sessionStorage.getItem('validationData'));
  }

  // Seta o validationData ja formatado, caso possivel
  setValidationData(data: any) {
    if (data?.byParameter) {
      const parameter = data.byParameter;
      const validationData = this.getValidationData();
      this.validationData = { ...validationData, ...parameter };
    } else {
      this.validationData = data;
    }
    sessionStorage.setItem('validationData', JSON.stringify(this.validationData));
    localStorage.setItem('validationData', JSON.stringify(this.validationData));
  }

  // Seta o campo validationData a partir de um customer
  setValidationDataFromCustomer(customer: Customer) {
    this.validationData = {
      'cnpj': customer.cnpj,
      'cpf': customer.cpf,
      'email': customer.email,
      'businessId': customer.provisioningParameter ? customer.provisioningParameter.businessId : null,
      'userId': customer.provisioningParameter ? customer.provisioningParameter.userId : null,
      'allowAutomaticRecharge': customer.provisioningParameter ? customer.provisioningParameter.allowAutomaticRecharge : null
    };

    sessionStorage.setItem('validationData', JSON.stringify(this.validationData));
    localStorage.setItem('validationData', JSON.stringify(this.validationData));
  }

  getUserIdBusinessId() {
    return {
      'userId': this.getUserId(),
      'businessId': this.getBusinessId()
    };
  }

  getUserId(): string {
    let userId = sessionStorage.getItem('userId');
    return userId == "undefined" || userId == "null" ? this.userId : userId;
  }

  getBusinessId(): string {
    let businessId = sessionStorage.getItem('businessId');
    return businessId == "undefined" || businessId == "null" ? this.businessId : businessId;
  }

  getSelectedIndex() {
    return this.paymentMethodIndex || sessionStorage.getItem('paymentMethodIndex');
  }

  getCustomer() {
    return this.customer || JSON.parse(sessionStorage.getItem('customer'));
  }



  getPaymentMethodIdentifier() {
    return this.paymentMethodIdentifier || sessionStorage.getItem('paymentMethod');
  }

  // SETTERS
  setUserIdAndBusinessId(userId: string, businessId: string, logon: string | null = null, distributor: string | null = null) {
    this.userId = userId;
    this.businessId = businessId;
    this.logon = logon;
    sessionStorage.setItem('userId', userId);
    sessionStorage.setItem('businessId', businessId);
    if (logon) {
      sessionStorage.setItem('logon', logon);
    }
    if (distributor) {
      sessionStorage.setItem('distributor', distributor);
    }
  }

  setClassification(classification: string) {
    this.classificationIdentifier = classification;
    sessionStorage.setItem('classificationIdentifier', this.classificationIdentifier);
  }

  setProduct(product: string) {

    this.product = product;
    sessionStorage.setItem('product', this.product);
  }
  getTrustConsultationData() {
    const data = sessionStorage.getItem('trustConsultationData');
    return data ? data : null;
  }

  setTrustConsultationData(data: any) {
    sessionStorage.setItem('trustConsultationData', JSON.stringify(data));
  }
  setPixPaid(isPixPaid: boolean): void {
    this.isPixPaid = isPixPaid;
    sessionStorage.setItem('isPixPaid', String(isPixPaid));
  }

  getPixPaid(): boolean {
    const value = sessionStorage.getItem('isPixPaid');
    return value !== null && value === 'true';
  }
  setPaymentMethodIdentifier(pmIdentifier: string) {
    this.paymentMethodIdentifier = pmIdentifier;
    sessionStorage.setItem('paymentMethod', this.paymentMethodIdentifier);
  }

  setSelectedIndex(idx) {
    this.paymentMethodIndex = idx;
    sessionStorage.setItem('paymentMethodIndex', this.paymentMethodIndex.toString());
  }

  setCoupon(couponIdentifier: string) {
    this.coupon = couponIdentifier;
    sessionStorage.setItem('coupon', this.coupon);
  }

  getCoupon() {
    return sessionStorage.getItem('coupon');
  }

  getNotLoggedSale() {
    return sessionStorage.getItem('notLoggedSale') === 'true';
  }

  getClassificationName() {
    return this.classificationName || sessionStorage.getItem('classificationName');
  }

  setClassificationName(name: string) {
    this.classificationName = name;
    sessionStorage.setItem('classificationName', this.classificationName);
  }

  getShopWindowRoute(): string {
    return sessionStorage.getItem("shopWindowRoute");
  }

  setShopWindowRoute(route: string) {
    sessionStorage.setItem("shopWindowRoute", route);
  }

  setBreadcrumbTrail(breadcrumbTrail) {
    const data = JSON.stringify(breadcrumbTrail);
    sessionStorage.setItem("breadcrumbTrail", data);
  }

  getBreadCrumbTrail(): BreadcrumbItemInterface[] {
    const data = sessionStorage.getItem("breadcrumbTrail");

    return data ? JSON.parse(data) : null;
  }

  deleteBreadcrumbTrail() {
    sessionStorage.removeItem("breadcrumbTrail");
  }

  getAdditionalData(parameter?: string) {
    const data = sessionStorage.getItem("additionalData");
    try {
      const parsedData = JSON.parse(data) ?? {};
      return parameter ? parsedData[parameter] : parsedData;
    } catch (_) {
      return {};
    }
  }

  setAdditionalData(data) {
    let newData;

    if (data?.byParameter) {
      const parameter = data.byParameter;
      const additionalData = this.getAdditionalData();
      newData = { ...additionalData, ...parameter };
    } else {
      newData = data;
    }

    sessionStorage.setItem('additionalData', JSON.stringify(newData));
  }

  setOneClickPurchase(oneClickPurchase: boolean) {
    sessionStorage.setItem('oneClickPurchase', oneClickPurchase.toString());
  }

  setOneClickPurchaseData(oneClickPurchaseData: { isDefaultCard: boolean; name: string; nickname: string; isAdyen: boolean; brand: string; accountPaymentDataId: string; cardNumber: string; situation: string; changePayment: boolean; }) {
    sessionStorage.setItem('oneClickPurchaseData', JSON.stringify(oneClickPurchaseData));
  }

  getOneClickPurchaseData() {
    return JSON.parse(sessionStorage.getItem('oneClickPurchaseData'));
  }

  setPurchaseOrigin(value: string) {
    sessionStorage.setItem('purchaseOrigin', value);
  }

  getPurchaseOrigin() {
    return sessionStorage.getItem('purchaseOrigin');
  }
  removeCoupon() {
    sessionStorage.removeItem('coupon');
  }

  setCustomData(key: string, data: any) {
    sessionStorage.setItem(key, data);
  }

  getCustomData(key: string): string {
    return sessionStorage.getItem(key);
  }

  setAdobeMobileData(rawData: string) {

  if (sessionStorage.getItem('adobeMobileData')) {
    return;
  }

  try {
    if (new TextEncoder().encode(rawData).length > 10240) {
      console.warn('adobeMobileData excede o limite de 10KB.');
      return;
    }

    const decodedData = decodeURIComponent(rawData);
    
    JSON.parse(decodedData);
    
    sessionStorage.setItem('adobeMobileData', decodedData);
    
  } catch (error) {
    console.warn('adobeMobileData inválido:', error);
  }
}
}
